const digestString = (str: string) =>
    window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then((hashBuffer) =>
        Array.from(new Uint8Array(hashBuffer))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join(''),
    );

export { digestString };
